export enum CatalogsHubCommands {
    REGISTER_BY_ACCOUNT_ID = 'registerByAccountId',
    REGISTER_BY_CATALOG_ID = 'registerByCatalogId',
    UNREGISTER_BY_ACCOUNT_ID = 'unRegisterByAccountId',
    UNREGISTER_BY_CATALOG_ID = 'unRegisterByCatalogId',
    UNREGISTER_RETRO_BY_ACCOUNT_ID = 'unRegisterRetroByAccountId',
    UNREGISTER_RETRO_BY_CATALOG_ID = 'unRegisterRetroByCatalogId'
}

export enum CatalogsHubEvents {
    INPUT_SYNC_STARTED = 'inputSyncStarted',
    INPUT_SYNC_FINISHED = 'catalogSyncFinished',
    CREATE_OUTPUT_STARTED = 'createOutputStarted',
    CREATE_OUTPUT_FINISHED = 'createOutputFinished',
    PHASE_COMPLETED = 'phaseCompleted',
    CATALOG_SYNC_FINISHED = 'inputSyncFinished',
    CATALOG_TEMPLATE_CHANGE = 'catalogTemplateChanged',
    CREATIVE_PRODUCTION_READY = 'creativeProductionReady'
}
